/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : AppOpenEvaluationExecutor.ts
*******************************************/

import { isProposeOpenInApp, isProposeOpenInAppWithScheme, ProposeOpenInApp, ProposeOpenInAppWithScheme } from "../../EvaluatedAction.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { CTAExecutionResult, EvaluatedActionExecutor, isDismissedCTA, NamedCtaEvaluator } from "../EvaluatedActionExecutor.js";
import { executeInAppOpen, executeInAppOpenWithScheme } from "../evaluations/NativeAppActionsProposal.js";

export class AppOpenEvaluationExecutor implements EvaluatedActionExecutor {
    public isExpectedType = (x) => isProposeOpenInApp(x) || isProposeOpenInAppWithScheme(x);

    constructor(
        private readonly sdk: ClientSdkPublicInterface,
        private logger: Logger
    ) {

    }

    execute(evaluator: NamedCtaEvaluator, res: ProposeOpenInApp | ProposeOpenInAppWithScheme, data?: any ): Promise<CTAExecutionResult> {
        return this.sdk.getGui().then(
            gui => {
                return gui.suggestInAppOpen(res.data).then(yes => {
                    if (isDismissedCTA(yes)) {
                        return CTAExecutionResult.DISMISSED;
                    }
                    else {
                        if(yes) {
                            const rval = isProposeOpenInAppWithScheme(res) ? executeInAppOpenWithScheme(res.data, this.sdk) : executeInAppOpen(res.data, this.sdk);
                            return rval.then(
                                () => CTAExecutionResult.COMPLETED
                            );
                        }
                        else {
                            return CTAExecutionResult.NOT_EXECUTED;
                        }
                    }

                    
                });
            }
        );
    }

}
